import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: 'financingStatus', method: 'GET', body: null, token: token })
}
